/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps, useParams } from 'react-router-dom';
import { getUrlParameter, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { Table, Button, Space, Spin, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { getComptables } from './comptable-reducer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { getSession } from 'app/shared/reducers/authentication';
export const Comptable = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const { match } = props;
  const comptable = useAppSelector(state => state.comptable.entities);
  const loading = useAppSelector(state => state.comptable.loading);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );

  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getComptables(props.match.params.ecoleid));
  }, []);

  const columns = [
    {
      title: 'Prénom',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'E-Mail',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Option',
      key: 'action',
      dataIndex: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/comptable/${currentEcole && currentEcole.id}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const data = comptable.map((compt, i) => ({
    id: compt.id,
    nom: compt.lastName,
    prenom: compt.firstName,
    email: compt.email,
  }));

  return (
    <div>
      <h2 id="comptable-heading" data-cy="ComptableHeading">
        <Translate contentKey="korischoolApp.comptable.home.title">Comptables</Translate>
        {isNotComptable && isNotSurveillantGeneral && (
          <div style={{ textAlign: 'right' }}>
            <Link
              to={`/comptable/${currentEcole && currentEcole.id}/new`}
              className="btn jh-create-entity"
              style={{ backgroundColor: '#F28E19', color: 'white' }}
              id="jh-create-entity"
              data-cy="entityCreateButton"
            >
              <FontAwesomeIcon icon="plus" />
              &nbsp;
              <Translate contentKey="korischoolApp.comptable.home.createLabel">Create new Comptable</Translate>
            </Link>
          </div>
        )}
      </h2>
      <div className="table-responsive">
        <Spin spinning={loading} tip="Chargement...">
          <Table columns={columns} dataSource={data} bordered pagination={{ pageSize: 10 }} />
        </Spin>
      </div>
    </div>
  );
};

export default Comptable;
